module.exports = __webpack_public_path__ + "media/img/payments/card-gray-icon-91ad56a0b05abb5a9eee9517cdd78952.png";